module.exports = __webpack_public_path__ + "media/images/athletes/2198-69e438ff6268729b6620723e58b23b92.png";